// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsHoldingsHistoryModule } from './app.module';
bootstrapAppModule(MutualFundsHoldingsHistoryModule);
